@if (direction == 'down') {
  <svg
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    >
    <path d="M5 11L4.37114e-07 6L10 6L5 11Z" [attr.fill]="color" />
    <rect
      x="6"
      y="6"
      width="2"
      height="6"
      transform="rotate(-180 6 6)"
      [attr.fill]="color"
      />
    </svg>
  }

  @if (direction == 'up') {
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      >
      <path d="M5 0L10 5H0L5 0Z" [attr.fill]="color" />
      <rect x="4" y="5" width="2" height="6" [attr.fill]="color" />
    </svg>
  }
